<template>
    <div>
        <div class="reportmodal reportcustom-modal">
            <div class="reportmodal-content reportmodal-sm reportmodal-border-radius">
                <div class="reportmodal-header">
                    <div class="row ">
                        <h3 type="h1">Generate Payroll Reports</h3>
                    </div>
                    <div>
                        <img src="@/assets/close.png" class="close-img" @click="closeReportModal" alt="" />
                    </div>
                </div>
                <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
                <div class="reportmodal-body">
                    <div class="uploadMethoRadio">
                        <tl-radio name="uploadType" label="Selected Employees" id="selectedEmployees"
                            value="selectedEmployees" v-model="selectedMethod" />
                        <tl-radio name="uploadType" label="All Employees" id="allEmployees" value="allEmployees"
                            v-model="selectedMethod" />
                    </div>
                    <p class="selectedFeature margintop-32" v-if="selectedMethod == 'selectedEmployees'">{{ warningMessage }}</p>

                    <div class="margintop-32" v-if="selectedMethod == 'selectedEmployees'">
                        <h4 class="employeeTitle">Select Employees</h4>
                        <textarea class="form-control custom-text-area margintop-16" rows="8" name="selectEmp"
                            v-model="details" placeholder="Enter employee codes seperated by comma ( , ) Max 5 only" />
                    </div>
                    <p class="selectedFeature" v-if="selectedMethod == 'selectedEmployees'">Use selected employee
                        generation feature for validating the Payroll reports instantly*</p>
                    <p class="selectedFeature margintop-32" v-else>Use selected employee generation feature for
                        validating the Payroll reports instantly. Use this feature only after client sign off the
                        "Salary register"</p>
                    <div class="margintop-32">
                        <v-btn class="mt-2 mb-2 customButton" color="#5d409f" elevation="0" :loading="generateLoading"
                            @click="generateReports">Generate</v-btn>
                    </div>
                </div>
                <div class="reportmodal-footer">
                    <btn class="mt-2 mb-2" text="Cancel" type="secondary" @click="closeReportModal"></btn>
                </div>
            </div>
            <pop-up-message popupHeaderMessage="Warning" v-if="showConfirmPopup"
                message="You are going to generate Payslip and Tax sheet for all the employees. Are you Sure? If yes, please wait for 15 mins to generate the reports."
                :popupType="'Warning'">
                <template v-slot:bottomContent>
                    <div class="popup-btn-group">
                        <button class="btn-popup-secondary" type="button" @click="goBackGenerate">
                            <b>No</b>
                        </button>
                        <v-btn class="btn-popup confirmButton" color="#5d409f" elevation="0" :loading="reportLoading"
                            @click="generatePayrollReports">
                            <b>Yes</b>
                        </v-btn>
                    </div>
                </template>
            </pop-up-message>
            <pop-up-message v-if="showSuccessMsg" :message="successMessage" :popupType="'Success'"
                popupHeaderMessage="Success">
                <template v-slot:bottomContent>
                    <div class="popup-btn-group">
                        <button class="btn-popup-secondary" type="button" @click="showSuccessMsg = false">
                            <b>Back</b>
                        </button>
                    </div>
                </template>
            </pop-up-message>
        </div>
    </div>
</template>
<script>

import { mapActions, mapState, mapGetters } from "vuex";

export default {
    props: {
        showReportModal: {
            type: Boolean
        },
        generatePayload: {
            type: Object
        },
        warningMessage: {
            type: String,
        },
    },

    data() {
        return {
            selectedMethod: "selectedEmployees",
            details: '',
            showConfirmPopup: false,
            toast: false,
            errmsg: '',
            showSuccessMsg: false,
            successMessage: '',
            selectedEmployeesCount: [],
            generateLoading: false,
            reportLoading: false
        };
    },
    mounted() {
        this.getOrgLeIdList();
        //this.reportDataTransfer();
    },

    activated() {
        this.getOrgLeIdList();
    },

    computed: {
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID",
        }),

        le_id() {
            if (this.$route.params.entity_index)
                return this.getleid(this.$route.params.entity_index);
            else return this.getleid(0);
        },
    },

    methods: {

        ...mapActions({
            getOrgLeList: "onboard/organization/getOrgLeIdList",
            act_generate_payroll_reports: "dashboard/payroll/monthlypayroll/lockPayroll/generatePayrollReports"
        }),

        closeReportModal() {
            this.$emit('closeReportModal');
        },

        goBackGenerate() {
            this.showConfirmPopup = false;
        },

        generateReports() {
    this.generateLoading = true;

    if (this.selectedMethod != 'selectedEmployees') {
        this.showConfirmPopup = true;
        this.$emit('selectedEmployeesFlag', false);
    } else {
        this.selectedEmployeesCount = this.details
            .split(',')
            .map(element => element.trim())
            .filter(element => element !== '');
        if (this.selectedEmployeesCount.length > 5) {
            this.toast = true;
            this.errmsg = 'More than 5 employees, Please enter only 5 employee codes';
        } else if (this.selectedEmployeesCount.length == 0) {
            this.toast = true;
            this.errmsg = 'Please enter at least one employee code';
        } else {
            this.$emit('selectedEmployeesFlag', true);
            this.generatePayrollReports();
        }
    }
    this.generateLoading = false;
},


        async generatePayrollReports() {
            this.reportLoading = true;
            try {
                let obj = {
                    leId: this.le_id,
                    month: this.generatePayload.month,  // Use formatted month from props
                    year: this.generatePayload.year,
                    empCode: this.selectedMethod == 'selectedEmployees' ? this.selectedEmployeesCount : []
                }
                let response = await this.act_generate_payroll_reports(obj);
                if (response && response.data && response.data.success) {
                    this.showConfirmPopup = false;
                    this.showSuccessMsg = true;
                    this.successMessage = this.selectedMethod == 'selectedEmployees' ? "Successfully Generated." : "Success, Please wait for 15 mins to validate the reports."
                }
                this.reportLoading = false;
                this.$emit('closeReportModal');
            } catch (error) {
                this.showConfirmPopup = false;
                this.$emit('closeReportModal');
                this.toast = true;
                this.errmsg = error;
                this.reportLoading = false;
            }
        },

        async getOrgLeIdList() {
            const org = this.orgId;
            const le = this.le_id;
            //console.log("Org:", org);
            //console.log("Le ID", le);
            let bodyParams = {};
            let data = await this.getOrgLeList({
                data: {
                    ...bodyParams
                }
            });
            this.role = data.data.user.userRole;
            this.reportosValue = data.data.user.permissions.reportos ? true : false;
        },
    }
};
</script>

<style lang="scss" scoped>
.reportHeading {
    margin-bottom: 30px;
    color: #777777;
}

.selectedFeature {
    color: red;
    font-weight: 500;
    font-size: 1rem;
}

.uploadMethoRadio {
    display: flex;
    align-items: center;
    // margin-top: 20px;
    gap: 10px;
}
.form-control {
    width: 450px !important;
}
::v-deep .custom-text-area{
    min-height: 0px !important;
}
.custom-text-area {
    width: 50%;
    // height: 80%;
}
.custom-text-area::placeholder {
  font-size: 13px; 
}


.customButton {
    display: block;
    border-radius: 4px;
    background-color: #5d409f;
    color: #ffffff;
    font-weight: bold;
    width: 25%;
    min-height: 45px;
    padding: 14px;
    transition: all 0.5s ease;
    text-transform: capitalize;
    margin: 0;
}

.customButton:hover {
    opacity: 0.8;
}

.confirmButton {
    margin: 0;
    text-transform: capitalize;
}

.reportmodal-footer {
    padding: 5px 0;
    display: flex;
    justify-content: flex-end;
    border-top: solid 1px #F0F0F0;
}

.content-width {
    min-width: 20%;
}

.reportTitle {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    margin-left: 20px;
    margin-right: 20px;
    // align-self: start;
}

.reportTitle>h3 {
    color: #34C0BD;
    margin-bottom: 5px;
}

.reportTitle>p {
    color: #777777;
    margin: 0;
}

.reportArrow>img {
    align-self: end;
}


.reportbutton {
    border: none;
    color: #FFF;
    background: #42b983;
    appearance: none;
    font: inherit;
    font-size: 1.8rem;
    padding: .5em 1em;
    border-radius: .3em;
    cursor: pointer;
}

.reportcustom-modal {
    &.reportmodal {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 6;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .reportmodal-body {
        height: 80%;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 20px;
        overflow-y: auto;
        max-height: calc(100vh - 200px);
        // padding: 0 10px 50px 0;
    }

    //   .reportmodal thead{
    //     overflow: visible;
    //   }
    /* Modal Content */
    .reportmodal-content {
        background-color: white;
        z-index: 2;
        border-radius: 8px;
        width: 40%;
        // min-height: 300px;
        // max-height: 80%;

        .reportmodal-header {
            display: flex;
            align-items: center;
            height: 50px;
            padding: 20px;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            border: solid 1px #F0F0F0;
            background-color: #ffffff;

            h3 {
                font-weight: 600;
                color: #34C0BD;
            }
        }

        .modal-footer {
            padding: 15px;
            text-align: right;
            border-top: 1px solid #34C0BD;
        }
    }
}
</style>